import AuthService from "utils/authService";

import qs from "qs";

import axios from "axios";

const axiosInstance = axios.create();

export function configureAxiosInstance() {
  axios.interceptors.request.use(
    (request) => {
      request.headers.set("X-REQUEST-URI", window.location.pathname);
      request.headers.set("Diverst-UserToken", AuthService.getJwt());
      return request;
    },
    (error) => Promise.reject(error),
  );

  // Add a request interceptor
  axiosInstance.interceptors.request.use(
    // Do something before request is sent
    (request) => {
      request.headers.set("X-REQUEST-URI", window.location.pathname);
      request.headers.set("Diverst-UserToken", AuthService.getJwt());
      return request;
    },
    // Do something with request error
    (error) => Promise.reject(error),
  );

  // Add a response interceptor
  axiosInstance.interceptors.response.use(
    // Do something with response data
    (response) => response,
    (rejection) => {
      if (!rejection.response) {
        rejection.response = { data: "Server Unavailable" };
      } else if (rejection.response.data && rejection.response.data.message) {
        rejection.response.data = rejection.response.data.message;
      } else if (rejection.response.status === 500) {
        rejection.response.data =
          "Internal Server Error. Please contact support@diverst.com";
      } else if (rejection.response.status === 503) {
        rejection.response.data = "Server Unavailable";
      }

      // Do something with response error
      return Promise.reject(rejection);
    },
  );

  // Format nested params correctly
  axiosInstance.interceptors.request.use((config) => {
    config.paramsSerializer = {
      serialize: (params) =>
        qs.stringify(params, {
          arrayFormat: "brackets",
          encode: false,
        }),
      indexes: null,
    };

    return config;
  });
}

export { axiosInstance as axios };
